var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"investment-plans-page"}},[_c('LandingBanner'),_c('Simulator'),_c('PlansDetail'),_c('FAQs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }